import { ApiPath } from 'common/enums/http/api-path';
import type { ServiceTablesLastUpdate } from 'models/service-tables-last-update';
import { http } from 'services/http';

export const getServiceTableLastUpdate = () =>
  http.get<ServiceTablesLastUpdate>(ApiPath.SERVICE_TABLES_LAST_UPDATE);
